// extracted by mini-css-extract-plugin
export default {"row":"Anamnese_row__PsJ9m","label":"Anamnese_label__05mwX","FormGroup":"Anamnese_FormGroup__IdfSC"};